<template>
    <div>
        <div :class="contentClass">
            <v-radio
                class="stack-s"
                label="True"
                :value="true"
                :group="stateGroupName"
                :model="value"
                @update="v => value = v"
            />
            <v-radio
                label="False"
                :value="false"
                :group="stateGroupName"
                :model="value"
                @update="v => value = v"
            />
        </div>
        <filter-footer
            @apply-filter="applyFilter"
            @cancel-filter="cancelFilter"/>
    </div>
</template>

<script>
    import {vRadio} from '@/components/form';
    import FilterFooter from '@/modules/rules-engine/components/condition-builder/filters/filter-footer';
    import BaseFilterMixin from '@/modules/rules-engine/components/condition-builder/filters/base-filter-mixin';
    import CriteriaCondition from '@/components/query/spec/criteria-condition';
    import ConditionOperators from '@/components/query/spec/condition-operators';

    export default {
        name: 'boolean-filter',
        mixins: [BaseFilterMixin],
        components: {
            FilterFooter,
            vRadio,
        },
        computed: {
            stateGroupName() {
                return `${this.condition.getPath()}/state`;
            },
        },
        data() {
            return {
                value: this.condition.data.value === null ? true : this.condition.data.value,
            };
        },
        methods: {
            applyFilter() {
                this.condition.data = new CriteriaCondition({
                    op: ConditionOperators.equals,
                    path: this.condition.getPath(),
                    value: this.value,
                });
                const payload = {
                    index: this.index,
                    condition: this.condition,
                };
                this.$emit('apply-filter', payload);
            },
        },
    };
</script>
